/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiChartFromJSON, ApiChartToJSON, } from './ApiChart';
import { ApiReportTabFromJSON, ApiReportTabToJSON, } from './ApiReportTab';
import { ApiTabElementFromJSON, ApiTabElementToJSON, } from './ApiTabElement';
export function ApiTabChartFromJSON(json) {
    return ApiTabChartFromJSONTyped(json, false);
}
export function ApiTabChartFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'attributes': !exists(json, 'attributes') ? undefined : json['attributes'],
        'chart': !exists(json, 'chart') ? undefined : ApiChartFromJSON(json['chart']),
        'chartId': !exists(json, 'chartId') ? undefined : json['chartId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'order': !exists(json, 'order') ? undefined : json['order'],
        'overridingChart': !exists(json, 'overridingChart') ? undefined : ApiChartFromJSON(json['overridingChart']),
        'overridingChartId': !exists(json, 'overridingChartId') ? undefined : json['overridingChartId'],
        'tab': !exists(json, 'tab') ? undefined : ApiReportTabFromJSON(json['tab']),
        'tabElement': !exists(json, 'tabElement') ? undefined : ApiTabElementFromJSON(json['tabElement']),
        'tabElementId': !exists(json, 'tabElementId') ? undefined : json['tabElementId'],
        'tabId': !exists(json, 'tabId') ? undefined : json['tabId'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiTabChartToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'attributes': value.attributes,
        'chart': ApiChartToJSON(value.chart),
        'chartId': value.chartId,
        'id': value.id,
        'order': value.order,
        'overridingChart': ApiChartToJSON(value.overridingChart),
        'overridingChartId': value.overridingChartId,
        'tab': ApiReportTabToJSON(value.tab),
        'tabElement': ApiTabElementToJSON(value.tabElement),
        'tabElementId': value.tabElementId,
        'tabId': value.tabId,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
